export const checkDomainExist = () => {
    const baseURL: string = process.env.REACT_APP_API_URL as string;
    return fetch(`${baseURL}api/v1/login_info`, {
        method: "GET",
        headers: {
            Accept: "application/json",
        }
    }).then((data) => data.json());
};
